import { trackAmplitudeEvent } from '../amplitudeLoader'

export const trackEvent = (name: string, props?: Record<string, unknown>) => {
  trackAmplitudeEvent(name, props)
}

export const setUserProperties = (props: Record<string, unknown>) => {
  if (typeof window === 'undefined' || !window.amplitude) return
  try {
    const identify = new window.amplitude.Identify()
    Object.entries(props).forEach(([k, v]) => identify.set(k, v))
    window.amplitude.identify(identify)
  } catch {
    // Amplitude not yet loaded — silently ignore
  }
}
